var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNearby(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33955 18.3818L25.6056 1.47798L48.8717 18.3818L39.9848 45.7327H11.2264L2.33955 18.3818Z",
    stroke: "#3D8ECC",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3327 20.5246C14.9966 20.1966 14.9966 19.6647 15.3327 19.3367L18.9842 15.7728C19.3203 15.4448 19.8653 15.4448 20.2014 15.7728L26.2872 21.7126C26.6233 22.0406 26.6233 22.5725 26.2872 22.9006L22.6357 26.4644C22.2996 26.7925 21.7547 26.7925 21.4185 26.4644L15.3327 20.5246ZM17.1585 19.9307L22.0271 24.6825L24.4615 22.3066L19.5928 17.5547L17.1585 19.9307Z",
    fill: "#555555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4615 29.4343C24.1254 29.1063 24.1254 28.5744 24.4615 28.2464L28.113 24.6825C28.4491 24.3545 28.994 24.3545 29.3302 24.6825L35.416 30.6223C35.7521 30.9503 35.7521 31.4822 35.416 31.8102L31.7645 35.374C31.4284 35.7021 30.8834 35.7021 30.5473 35.374L24.4615 29.4343ZM26.2872 28.8403L31.1559 33.5921L33.5902 31.2162L28.7216 26.4644L26.2872 28.8403Z",
    fill: "#555555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7228 22.0097C22.059 21.6817 22.6039 21.6817 22.94 22.0097L29.0259 27.9494C29.362 28.2775 29.362 28.8093 29.0259 29.1374C28.6897 29.4654 28.1448 29.4654 27.8087 29.1374L21.7228 23.1976C21.3867 22.8696 21.3867 22.3377 21.7228 22.0097Z",
    fill: "#3D8ECC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearby);
export default __webpack_public_path__ + "static/media/nearby.d4e028260e541e362a3a48151fb89473.svg";
export { ForwardRef as ReactComponent };